/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import { FindColleagues_api } from "./ColleaguesAPI";
import Header from '../Header/HeaderNoDropdown'

import Sidebar from '../Sidebar/Sidebar'
import ProfileImg from "../../assets/images/profileImg.jpg"
import WhiteLocation from "../../assets/images/icons/white-location.svg"
import NoData from "../../assets/images/icons/no-data-page.png"
import logo from "../../assets/images/logo-big.svg"

import orangestar from "../../assets/images/icons/orange-star.svg"
import notification from "../../assets/images/icons/notification.svg"
import profileImg from "../../assets/images/profileImg.jpg"
import edit from "../../assets/images/icons/edit.svg"
import logoutwhite from "../../assets/images/icons/logout-white.svg"
import Profile from "../../assets/images/profile.png"
import ProfileLocation from "../../assets/images/icons/profile-location.svg"
import FillStar from "../../assets/images/icons/fill-star.svg"
import GrayStar from "../../assets/images/icons/gray-star.svg"
import BlackClose from "../../assets/images/icons/black-close.svg"
import loadingGIF from "../../assets/images/loading.gif"

import { useTranslation } from 'react-i18next'
import NotificationPanel from '../Common/Notification'
import { useHistory } from 'react-router-dom';
import CustomSearchableCheckboxDropdown from '../Common/CustomSearchableCheckboxDropdown';
import CustomSearchableCheckboxDropdownWithLable from '../Common/CustomSearchableCheckboxDropdownWithLable';
import CreditInfoCard from '../Common/CreditInfoCard';
import { formatDateToEEEddMMM } from '../../utils/CommonUtils';
import { useApiUiResponse } from "../../hooks/apiUiResponseHelper.js";

function Colleagues({ userCredit, creditBalanceRefill }) {
  const [isLoading, setIsLoading] = useState(false);
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);
  const [groups, setGroups] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchBookings, setSearchBookings] = useState([]);
  const [mapAvailableType, setMapAvailableType] = useState();

  const [zones, setZones] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [zoneDropdownOpen, setZoneDropdownOpen] = useState(false);
  const [selectedZoneIds, setSelectedZoneIds] = useState(null);
  const [selectedColleagueId, setSelectedColleagueId] = useState(0);
  const [selectedColleagueName, setSelectedColleagueName] = useState("");

  const { t } = useTranslation()
  const history = useHistory();
  const { handleApiUiResponse, renderApiUi } = useApiUiResponse(t);

  const getFirstName = () => sessionStorage.getItem("firstname");

  const [creditBalanceRefillEvery, setCreditBalanceRefillEvery] = useState("");
  const [isThumbnailPresent, setIsThumbnailPresent] = useState(0);
  const [companyId, setCompanyId] = useState(0);
  const [creditBalance, setCreditBalance] = useState(0);
  const [zoneCreditValue, setZoneCreditValue] = useState(0);
  const expandedLogoUrl = companyId
    ? `https://ronlivestaging.s3.amazonaws.com/companylogo/${companyId}/logo.png`
    : "";
  const zoneDropdownValue =
    selectedZoneIds === null && zones.length > 0
      ? zones.map((zone) => zone.Id)
      : selectedZoneIds;

  useEffect(() => {
    document.title = `${t("react_colleagues")} | Ronspot`
  }, []);

  useEffect(() => {

    const fetchData = async () => {
      // 🚫 If no zone selected → clear list and stop API call
      /* if (!selectedZoneIds || selectedZoneIds.length === 0) {
        setSearchBookings([]);
        return;
      } */
      if (Array.isArray(selectedZoneIds) && selectedZoneIds.length === 0) {
        setSearchBookings([]);
        return;
      }

      setIsLoading(true);

      try {

        const zoneIdString =
          selectedZoneIds === null || selectedZoneIds.length === zones.length
            ? "0"
            : selectedZoneIds.join(",");

        const profileData = await FindColleagues_api({
          SearchMemberId: selectedColleagueId || 0,
          ZoneId: zoneIdString,
        });
        handleApiUiResponse(profileData, {
          successToaster: 0,
          errorToaster: 1,
          alertPopup: 1
        });
        const rec = profileData?.Data?.Records || {};

        //setZones(rec.ZoneList || []);
        const zoneList = rec.ZoneList || [];

        setZones(zoneList);

        // ✅ Select ALL zones only on first load
        setGroups(rec.UserList || []);
        setSearchBookings(rec.SearchBookings || []);
        setMapAvailableType(rec?.SearchBookings?.[0]?.MapType ?? 0);
        setCreditBalance(rec.CreditBalance);
        setZoneCreditValue(rec.ZoneCreditValue || 0);
        setCompanyId(rec.CompanyId);
        setCreditBalanceRefillEvery(rec.CreditBalanceRefillEvery);
        setIsThumbnailPresent(rec.IsThumbnailPresent);

      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setIsLoading(false);
      }

    };

    fetchData();

  }, [selectedZoneIds, selectedColleagueId]);


  useEffect(() => {
    if (searchTerm) {
      const results = groups.filter((colleague) =>
        colleague.FullName.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredResults(results);
    } else {
      setFilteredResults([]);
    }
  }, [searchTerm, groups]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".employee-list")) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);



  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    setSearchBookings([]);
    setSelectedColleagueId(0);
    setSelectedColleagueName("");

    if (value.trim() !== '') {
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  };

  const getGuId = () => sessionStorage.getItem("guId");
  const handleResultClick = (colleague) => {
    setSearchTerm(colleague.FullName);
    setFilteredResults([]);
    setShowDropdown(false);
    setSelectedColleagueId(colleague.Id);
    setSelectedColleagueName(colleague.FullName);
  };

  const GotoMapClick = (zoneId, bookingDateStr, mapType, mapExist) => {
    console.log("Map Click:", { zoneId, bookingDateStr, mapType, mapExist });

    if (mapType === 1 || mapType === 2 || mapType === 3) {

      history.push("/map", {
        selectedZoneId: zoneId,
        selectedDate: bookingDateStr
      });
    };
  };

  // utils/dateFormatter.js
  const formatBookingDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    // This creates: "Monday, 23 February"
    const formatted = new Intl.DateTimeFormat('en-GB', {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
    }).format(date);

    // This replaces spaces and commas with hyphens to get "Monday-23-February"
    return formatted
  };

  const headerTitle = t("react_hi").replace("%s", getFirstName());
  const noDataMessage = selectedColleagueId && selectedColleagueName
    ? t("react_colleague_has_no_bookings").replace("%s", selectedColleagueName)
    : t("react_colleagues_start_typing");

  return (
    <div>
      {renderApiUi(isLoading)}
      <div className='content-area colleagues-page'>
        {/* <Header /> */}
        <header className="header">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-3">
                <div className="greeting-title">
                  <p>{headerTitle}</p>
                </div>
              </div>

              <div className="col-md-6">
                <div className="row">
                  <div className="col-xl-9 offset-xl-3 col-lg-10 offset-lg-2">
                    <div className="filter-panel d-flex justify-content-end align-items-center gap-3">
                      <div className="filter-options d-flex gap-3 w-100">

                        <div className="employee-list location-list">
                          <div className="dropdown form-input-container d-flex justify-content-center flex-column">
                            <CustomSearchableCheckboxDropdownWithLable
                              items={zones}
                              value={zoneDropdownValue}
                              labelKey="CarParkName"
                              valueKey="Id"
                              placeholder={`${t("select_a_zone")}`}
                              multiple={true}
                              searchable={false}
                              showSelectAll={true}
                              onChange={(vals) => {
                                if (vals.length === 0) {
                                  setSelectedZoneIds([]);
                                } else if (vals.length === zones.length) {
                                  setSelectedZoneIds(null);
                                } else {
                                  setSelectedZoneIds(vals);
                                }
                                setSearchBookings([]);
                              }}
                              label={t("zone")}
                              // rootClassName="colleagues-zone-dropdown location-list"
                              rootClassName="colleagues-zone-list"
                            />

                          </div>
                        </div>
                        <div className="employee-list">
                          <div className="dropdown form-input-container d-flex justify-content-center flex-column">
                            <div className='dropdown-toggle form-control position-relative custom-dropdown-btn d-flex flex-column justify-content-center'>
                              <label className='sub-dropdown-name'>{t("react_colleagues")}</label>
                              <input
                                type="text"
                                placeholder={`${t("employee_name")}`}
                                value={searchTerm}
                                onChange={handleSearchChange}
                                id="emp-dropdown"
                              />
                            </div>
                            {showDropdown && filteredResults.length > 0 && (

                              <ul className='custom-dropdown show'>
                                {filteredResults.map((colleague) => (
                                  <li
                                    key={colleague.Id}
                                    onClick={() => handleResultClick(colleague)}
                                  >
                                    <a className='dropdown-item'>{colleague.FullName}</a>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div className="col-md-3">
                <div className="menu-bar-options d-flex justify-content-end gap-3">
{zoneCreditValue !== 0 && (
                  <CreditInfoCard
                    userZoneCreditValue={zoneCreditValue}
                    userZoneCreditBalance={creditBalance}
                    creditBalanceRefillEvery={creditBalanceRefillEvery}
                    IsThumbnailPresent={isThumbnailPresent}
                    CompanyId={companyId}
                  />
)}
                  <div className="notification-info">
                    <a href="#" data-bs-toggle="offcanvas" data-bs-target="#notification-panel" aria-controls="notification-panel" className="position-relative notification-icon">
                      <img src={notification} alt="" />
                      {hasUnreadNotifications && (
                        <span className="orange-dot"></span>
                      )}</a>
                  </div>
                  <NotificationPanel onUnreadChange={setHasUnreadNotifications} />

                </div>
              </div>
            </div>
          </div>
        </header>
        <div className="component-area colleagues-page">

          {isLoading && (
            <div id='preloader'>

              <img src={loadingGIF} alt="" />
            </div>
          )}
          <Sidebar
            IsThumbnailPresent={isThumbnailPresent}
            CompanyId={companyId}
          />
          <div className="pt-96 pb-96 my-container active-cont">
            <div className="container mw-100 pt-30">
              <div className="row">
                <div className="col-md-12">
                  {isLoading ? (
                    <a ></a>
                  ) : searchBookings.length > 0 ? (
                    <div className="table-details">
                      <h2 className='module-title mb-3'>{t("react_find_colleagues")}</h2>
                      <div className="table-container position-relative">
                        <table id="dynamicTable" className="table-details gridtable ">
                          <thead>
                            <tr>

                              <th>{t("name")}</th>
                              <th>{t("date")}</th>
                              <th>{t("time")}</th>
                              <th>{t("react_new_booking_spot")}</th>
                              <th>{t("zone")}</th>
                              <th>{t("react_details")}</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {searchBookings.map((booking, index) => (
                              <tr key={index}>
                                <td>
                                  <span>{selectedColleagueName || ""}</span>
                                </td>
                                <td>
                                  <span>
                                    {(() => {
                                      const bookingDate = new Date(booking.BookingDate);
                                      const today = new Date();
                                      today.setHours(0, 0, 0, 0);

                                      const tomorrow = new Date(today);
                                      tomorrow.setDate(tomorrow.getDate() + 1);

                                      bookingDate.setHours(0, 0, 0, 0);

                                      if (bookingDate.getTime() === today.getTime()) {
                                        return t("today");
                                      }

                                      if (bookingDate.getTime() === tomorrow.getTime()) {
                                        return t("tomorrow");
                                      }

                                      return formatDateToEEEddMMM(booking.BookingDate);
                                    })()}
                                  </span></td>

                                <td>
                                  <span>
                                    {booking.StartTime && booking.EndTime ? `${booking.StartTime} - ${booking.EndTime}` : t("all_day")}
                                  </span></td>
                                <td>
                                  <div className="name-with-icon">

                                    <img src={booking.BookingIcon} alt="" className="img-fluid" />

                                    {booking.SpotName}
                                  </div>
                                </td>
                                <td>{booking.ZoneName}</td>
                                <td>
                                  <div className="name-with-profile">
                                    <h3>{booking.MeetingName || ""}</h3> {/* Display the selected colleague's name here */}
                                  </div>
                                </td>
                                <td>
                                  <a
                                    href="#"
                                    className={`green-filled-with-icon2 ${(booking.MapExist === 1 && booking.UserZoneOccupied === 1) ? "" : "green-filled-with-icon2 disable"}`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      if (!((booking.MapExist === 1 && booking.UserZoneOccupied === 1))) return;
                                      GotoMapClick(
                                        booking.ZoneId,
                                        booking.BookingDate,
                                        booking.MapType,
                                        booking.MapExist
                                      );
                                    }}
                                  >
                                    <span>
                                      <img src={WhiteLocation} alt="" />
                                    </span>

                                  </a>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div className='table-details'>
                      <h2 className='module-title mb-3'>{t("react_find_colleagues")}</h2>
                      <div className='text-center py-5 my-5'>
                        <img src={NoData} className='img-fluid' alt="No data" />
                        <p className='mt-3'>{noDataMessage}</p>
                        <img
                          src={expandedLogoUrl || logo}
                          alt="Company logo"
                          className="img-fluid mt-2"
                          style={{ maxWidth: "220px" }}
                          onError={(event) => {
                            event.currentTarget.onerror = null;
                            event.currentTarget.src = logo;
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Colleagues;
